class TypographySupport{
	constructor() {
		// const webfontloader = require('webfontloader');
		// const families = ['Open Sans', 'Raleway'];
		// webfontloader.load({
		// 	google: {
		// 		families: families.map(family => {
		// 			return `${family}:100,200,300,400,500,600,700,800,900`;
		// 		}),
		// 	}
		// });
	}
}

window.app.add('typography-support', new TypographySupport());